import $ from 'jquery';
import { showModal, isAnyModalOpen } from "./modal-manager";

function isValidURL(string) {
  try {
    const url = new URL(string);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch (e) {
    return false;
  }
}
$(() => {
  $('body').on('click', 'a', function (event) {
    // Exclude the confirm link from triggering the modal
    if ($(this).attr('id') === 'confirm-link') {
      return;
    }
    if ($(this).data('skip-confirm-modal')) {
      return;
    }

    const currentDomain = window.location.hostname;
    const url = $(this).attr('href');

    if (!isValidURL(url)) {
      return;
    }

    const linkUrl = new URL(url, window.location.origin); // Create a URL object to extract the hostname
    // Domains considered as part of contrave should not show the leaving contrave modal
    const internalDomains = ['blog.contrave.com', 'doctors.contrave.com', 'curraxpharma.com', 'contravehcp.com', 'ls-directory.doctor.com', 'contrave.ca'];
    const externalDomain = linkUrl.hostname.replace(/^www\./, ''); // Remove 'www.' if exists from link

    // Check if the link points to a different domain
    if (linkUrl.hostname !== currentDomain && !internalDomains.includes(externalDomain)) {
      event.preventDefault(); // Prevent the default navigation

      // Set the modal's confirm link
      $('#confirm-link').attr('href', url);

      // Show the modal
      // if (!isAnyModalOpen()) {
      showModal('#modal-leaving-contrave');
      // }
    }
  });
});